import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CallState } from '@lcs/shared/api';
import { Observable } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { GetAccountDetail_account } from '../../queries/generated/GetAccountDetail';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-account-active-dates',
    styleUrls: [],
    templateUrl: './account-active-dates.component.html',
    standalone: false
})
export class AccountActiveDatesComponent implements FormComponent {
   form: UntypedFormGroup;

   callState$: Observable<CallState>;

   account: GetAccountDetail_account | null;

   title: string = 'Active Dates';

   constructor(
      private fb: UntypedFormBuilder,
      public dialogRef: MatDialogRef<AccountActiveDatesComponent>,
      public dialogService: LcsDialogService,
      @Inject(MAT_DIALOG_DATA)
      public data: {
         account: GetAccountDetail_account | null;
      }
   ) {
      this.account = data.account;
      this.form = this.fb.group({
         activeStartDate: fb.control(this.account?.activeStartDate),
         activeEndDate: fb.control(this.account?.activeEndDate),
      });
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onConfirm(): void {
      if (this.form.valid) {
         this.dialogRef.close(this.form.value);
      }
   }
}
